import { onMounted, onUnmounted, ref } from 'vue';

const SCREENS = {
	SM: 320,
	MD: 768,
	LG: 1024,
	XL: 1280,
};

export function useScreenSize() {
	const screenSize = ref(0);

	function setNewScreenSize() {
		screenSize.value = window.innerWidth;
	}

	setNewScreenSize();

	onMounted(() => {
		window.addEventListener('resize', setNewScreenSize);
	});

	onUnmounted(() => {
		window.removeEventListener('resize', setNewScreenSize);
	});

	return {
		isMobileResolution: () => screenSize.value < SCREENS.MD,
		isTabletResolution: () => SCREENS.MD <= screenSize.value && screenSize.value < SCREENS.LG,
		isDesktopResolution: () => screenSize.value >= SCREENS.LG,
		isLargeDesktopResolution: () => screenSize.value >= SCREENS.XL,
	};
}
